const MexicoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111890)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M40.0002 20.0008C40.0002 12.0716 35.3857 5.22035 28.6958 1.98535V38.0162C35.3857 34.7813 40.0002 27.93 40.0002 20.0008Z"
        fill="#D80027"
      />
      <path
        d="M0 20.0008C0 27.93 4.61445 34.7813 11.3044 38.0163V1.98535C4.61445 5.22035 0 12.0716 0 20.0008Z"
        fill="#6DA544"
      />
      <path
        d="M14.7827 20.0009C14.7827 22.8823 17.1187 25.2183 20.0001 25.2183C22.8816 25.2183 25.2176 22.8823 25.2176 20.0009V18.2617H14.7827V20.0009Z"
        fill="#6DA544"
      />
      <path
        d="M26.9566 16.5223H21.7392C21.7392 15.5619 20.9605 14.7832 20 14.7832C19.0396 14.7832 18.2609 15.5619 18.2609 16.5223H13.0435C13.0435 17.4829 13.8801 18.2615 14.8405 18.2615H14.7826C14.7826 19.222 15.5612 20.0006 16.5217 20.0006C16.5217 20.9612 17.3003 21.7398 18.2609 21.7398H21.7392C22.6997 21.7398 23.4783 20.9612 23.4783 20.0006C24.4388 20.0006 25.2174 19.222 25.2174 18.2615H25.1595C26.12 18.2615 26.9566 17.4829 26.9566 16.5223Z"
        fill="#FF9811"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111890">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MexicoSvg;
